import React from 'react';
import PropTypes from 'prop-types';
import { GoogleMap } from '@react-google-maps/api';
import { styles } from '../app/google_maps';

const center = { lat: 46.504063, lng: 6.451314 };
const mapContainerStyle = { height: '100%' };

const PlansMap = ({ zoom, mapType, children, onLoad, onClick, onZoomChanged }) => (
  <GoogleMap
    onLoad={onLoad}
    zoom={zoom}
    center={center}
    mapContainerStyle={mapContainerStyle}
    options={{
      disableDefaultUI: true,
      scrollwheel: true,
      disableDoubleClickZoom: true,
      mapTypeId: mapType,
      styles,
    }}
    onClick={onClick}
    onZoomChanged={onZoomChanged}
  >
    {children}
  </GoogleMap>
);

PlansMap.defaultProps = {
  onLoad: () => { },
  mapType: google.maps.MapTypeId.ROADMAP,
};

PlansMap.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  zoom: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  onZoomChanged: PropTypes.func.isRequired,
  onLoad: PropTypes.func,
  mapType: PropTypes.string,
};

export default PlansMap;
